import React, { useContext, useState } from "react";
import { Card } from "react-bootstrap";
import PsContext from "../../context";
import { Button, Divider, List, ListItem, ListItemText } from "@mui/material";
import DoneAllOutlinedIcon from "@mui/icons-material/DoneAllOutlined";
import { MuiConfirmWindow } from "../../utils";
import { _SAVE_ELECTIVE } from "../../models/elective";

const ViewSubjectDetails = (props) => {
  const context = useContext(PsContext);
  const [loader, setLoader] = useState(false);

  const [confirm, setConfirm] = useState(false);

  const field = (fieldName) => props?.subject?.[fieldName] || "";

  const fieldsNames = [
    { name: "subject_code", title: "Course Code" },
    { name: "subject_name", title: "Course Name" },
    { name: "subject_credit", title: "Course Credit" },
  ];

  const onConfirm = () => {
    context.setLoader(true);
    _SAVE_ELECTIVE({
      id: field("id"),
      elective_id: field("elective_title_id"),
      subject_id: field("subject_id"),
    }).then((res) => {
      if (res.status == "1") {
        context.setAlertMsg(res.message || "Success");
        if (props.onSuccess) props.onSuccess();
      } else {
        context.setAlertMsg(res.message || "Error");
      }
      context.setLoader(false);
    });
  };

  return (
    <>
      <div className="container-sm py-md-3">
        <Card>
          <Card.Header className="card-header-bg fw-bold text-uppercase">
            {field("elective_title")}
          </Card.Header>
          <Card.Body className="p-0">
            <List>
              {fieldsNames.map((item, i) => {
                return (
                  <>
                    <ListItem>
                      <ListItemText
                        secondary={item.title}
                        primary={field(item.name)}
                      />
                    </ListItem>
                    <Divider />
                  </>
                );
              })}
            </List>
            {!props.dataSource.selection_id &&
              !props.dataSource.selection_id_same_nature &&
              props.subject.total_vacant > 0 && (
                <div className="py-2 text-center">
                  <Button
                    variant="contained"
                    size="large"
                    startIcon={<DoneAllOutlinedIcon />}
                    onClick={(e) => setConfirm(true)}
                  >
                    Save as My Selection
                  </Button>
                </div>
              )}
          </Card.Body>
        </Card>
      </div>

      <MuiConfirmWindow
        open={confirm}
        onClose={(e) => setConfirm(false)}
        title="Confirm"
        cancelText="Cancel"
        okText="Confirm"
        onSuccess={(e) => {
          setConfirm(false);
          onConfirm();
        }}
      >
        Do you want to save the course <b>{field("subject_code")}</b> as your
        selection ?
        <br />
        <br />
        Once confirmed, your selection cannot be changed.
      </MuiConfirmWindow>
    </>
  );
};
export default ViewSubjectDetails;
